import {
  AnswerPayload,
  PositionAnswerPayload,
  Quiz,
  TagAnswerPayload,
} from '@services/common.services'
import {
  getQuiz,
  postQuiz,
  setInitPositions,
  setInitTags,
  setSurvey,
} from '@store/common/actions'
import { getQuizList } from '@store/common/selectors'
import { useAppDispatch } from '@store/hooks'
import { Meta } from '@store/metadata/actions/types'
import { createMetaSelector } from '@store/metadata/selectors'
import { useSelector } from 'react-redux'

interface QuizInterface {
  quiz: (params: AnswerPayload) => any
  fetchQuiz: () => any
  quizList: Quiz
  setTags: (params: TagAnswerPayload) => any
  setPositions: (params: PositionAnswerPayload) => any
  survey: (params: AnswerPayload) => any
  meta: Meta
  surveyMeta: Meta
  tagsMeta: Meta
  positionsMeta: Meta
  settingsMeta: Meta
}

const useQuiz = (): QuizInterface => {
  const dispatch = useAppDispatch()
  const quiz = (params: AnswerPayload) => dispatch(postQuiz(params))
  const fetchQuiz = () => dispatch(getQuiz())
  const quizList = useSelector(getQuizList)
  const setTags = (params: TagAnswerPayload) => dispatch(setInitTags(params))
  const setPositions = (params: PositionAnswerPayload) =>
    dispatch(setInitPositions(params))
  const survey = (params: AnswerPayload) => dispatch(setSurvey(params))
  const _meta = createMetaSelector(getQuiz)
  const meta = useSelector(_meta)
  const _surveyMeta = createMetaSelector(setSurvey)
  const surveyMeta = useSelector(_surveyMeta)
  const _tagsMeta = createMetaSelector(setInitTags)
  const tagsMeta = useSelector(_tagsMeta)
  const _positionsMeta = createMetaSelector(setInitPositions)
  const positionsMeta = useSelector(_positionsMeta)
  const _settingsMeta = createMetaSelector(postQuiz)
  const settingsMeta = useSelector(_settingsMeta)
  return {
    quiz,
    quizList,
    fetchQuiz,
    setTags,
    setPositions,
    survey,
    meta,
    surveyMeta,
    positionsMeta,
    tagsMeta,
    settingsMeta,
  }
}

export default useQuiz
